/** Textos de comprobantes del Eiffel (los campos vienen con espacios a la derecha). */

export const texto = (valor) => (valor ? String(valor).trim() : '');

/** Número que ve el usuario: el externo si lo tiene, si no el de referencia. */
export const numeroComprobante = (comprobante) => texto(comprobante.nroExterno) || comprobante.nroReferencia;

/** "Factura A 0004-00018231" (nombre del tipo, o su código si no tiene, y número). */
export const nombreComprobante = (comprobante) =>
  `${texto(comprobante.nombreComprobante) || texto(comprobante.idComproba)} ${numeroComprobante(comprobante)}`;

/** "FA - Factura A" */
export const tipoComprobante = (comprobante) => `${texto(comprobante.idComproba)} - ${texto(comprobante.nombreComprobante)}`;

/** A quién se envía: "proveedor" en los comprobantes de compras (Id_Sistema C), "cliente" en los de ventas. */
export const terceroComprobante = (comprobante) => (comprobante && texto(comprobante.idSistema) === 'C' ? 'proveedor' : 'cliente');

/** "C0142 - Ferretería El Tornillo SRL" (en compras, el proveedor) */
export const clienteComprobante = (comprobante) => `${texto(comprobante.idCliente)} - ${texto(comprobante.nombre)}`;

/** Importe pendiente de descargar de un renglón. */
export const importePendiente = (renglon) => renglon.cantPendiente * renglon.precioImpreso;
